import React from "react";
import { FaChevronLeft } from "react-icons/fa";

interface StepHeaderProps {
  currentStep: number;
  totalSteps: number;
  onCancel: () => void;
}

export const StepHeader: React.FC<StepHeaderProps> = ({
  currentStep,
  totalSteps,
  onCancel,
}) => {
  const steps = ["General Information", "Tool Category", "Selection"];

  return (
    <div className="mt-8 flex items-center">
      <div className="flex gap-2">
        <FaChevronLeft
          color="#334155"
          onClick={onCancel}
          className="cursor-pointer mt-1"
        />
        <div>
          <h1 className="text-xl font-semibold text-da-blue-600 inter">
            Add Tool
          </h1>
          <div className="flex gap-2 items-center mt-2">
            <span className="text-sm text-[#334155]">
              Step {currentStep} of {totalSteps}: {steps[currentStep - 1]}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

interface StepButtonsProps {
  currentStep: number;
  totalSteps: number;
  onPrevious: () => void;
  onNext: () => void;
  canProceed: boolean;
  isLoading: boolean;
  onCancel: () => void;
}

export const StepButtons: React.FC<StepButtonsProps> = ({
  currentStep,
  totalSteps,
  onPrevious,
  onNext,
  canProceed,
  isLoading,
  onCancel,
}) => {
  return (
    <div className="mt-8 w-full flex pb-8">
      <div className="lg:w-2/3 flex justify-center items-center gap-5">
        <button
          type="button"
          onClick={onCancel}
          className="px-10 py-3 text-base font-medium min-w-[140px] border-2 border-[#FECACA] text-[#EF4444] bg-transparent rounded hover:bg-red-50 transition-colors"
        >
          Cancel
        </button>

        {currentStep > 1 && (
          <button
            type="button"
            onClick={onPrevious}
            className="px-10 py-3 text-base font-medium min-w-[140px] border-2 border-gray-300 text-gray-700 bg-transparent rounded hover:bg-gray-50 transition-colors"
          >
            Previous
          </button>
        )}

        <button
          type="button"
          onClick={onNext}
          disabled={!canProceed || isLoading}
          className="px-10 py-3 text-base font-medium min-w-[140px] bg-[#3787FF] text-white rounded hover:bg-blue-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {isLoading
            ? "Loading..."
            : currentStep === totalSteps
            ? "Submit"
            : "Next"}
        </button>
      </div>
    </div>
  );
};

// Keep default export for backward compatibility
const StepNavigation: React.FC<StepButtonsProps & StepHeaderProps> = (
  props
) => {
  return (
    <>
      <StepHeader
        currentStep={props.currentStep}
        totalSteps={props.totalSteps}
        onCancel={props.onCancel}
      />
      <StepButtons {...props} />
    </>
  );
};

export default StepNavigation;
